export const systemFonts = new Set([
  'Arial',
  'Helvetica',
  'Helvetica Neue',
  'Verdana',
  'Calibri',
  'Segoe UI',
  'Times New Roman',
  'Georgia',
  'Garamond',
  'Courier New',
  'Lucida Console',
  'San Francisco',
]);
